import React from "react";
import { TIERS, MIN_DEPOSIT, REFER_COMMISSION } from "../data/offer";

/**
 * The PRO / MAX rate cards plus the two shared rows (min deposit, refer).
 * Rendered inside both the popup and the in-page download card.
 */
const OfferTiers = () => (
  <>
    <div className="tier-grid">
      {TIERS.map((tier) => (
        <div className={`tier-card tier-${tier.key}`} key={tier.key}>
          <div className={`tier-badge tier-badge-${tier.key}`}>
            {tier.label}
          </div>

          <div className="tier-row">
            <span className="tier-label">Jodi Rate</span>
            <strong className="tier-value value-green">{tier.jodiRate}</strong>
          </div>

          <div className="tier-row">
            <span className="tier-label">Haruf Rate</span>
            <strong className="tier-value value-green">{tier.harufRate}</strong>
          </div>

          <div className="tier-row">
            <span className="tier-label">Commission</span>
            <strong className="tier-value value-gold">{tier.commission}</strong>
            <span className="tier-note">{tier.commissionNote}</span>
          </div>
        </div>
      ))}
    </div>

    <div className="app-popup-rule-list">
      <div className="app-popup-rule-row">
        <span>Min Deposit</span>
        <strong className="value-gold">{MIN_DEPOSIT}</strong>
      </div>
      <div className="app-popup-rule-row">
        <span>Refer</span>
        <strong className="value-purple">{REFER_COMMISSION}</strong>
      </div>
    </div>
  </>
);

export default OfferTiers;
